$(document).ready(function() {
    // Show or hide the button depending on the scroll position
    $(window).scroll(function() {
        if ($(this).scrollTop() > 100) {
            $('#backToTop').fadeIn();
        } else {
            $('#backToTop').fadeOut();
        }
    });

    // Scroll to the top when the button is clicked
    $('#backToTop').click(function() {
        $('html, body').animate({scrollTop: 0}, 600);
        return false;
    });
});




$(document).ready(function() {  
  if (window.location.hash === "#csproduct-template--18716198076669__home_featured_product_LmdPMC") {
    var $productSection = $("#csproduct-template--18716198076669__home_featured_product_LmdPMC");
    if ($productSection.length) {
      $productSection[0].scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }
});





 $("li.drawer-menu__tier-1-item a").on('click', function() {
    var navtitle = $(this).text();
    
      if (navtitle == 'Shop') {
         var headerHeight = $('.header-nav').outerHeight()+10; // Adjust selector if needed
        // Calculate the position to scroll to
        var targetOffset = $("#shop").offset().top  - headerHeight;
        
        // Animate the scroll
        $('html, body').animate({
            scrollTop: targetOffset
        }, 500);
      }
       if (navtitle == 'About') {
        // Get the height of the header (if it's fixed, adjust accordingly)
        var headerHeight = $('.header-nav').outerHeight()+10; // Adjust selector if needed
        
        // Calculate the position to scroll to
        var targetOffset = $(".media-and-text-wrapper.template--18716198076669__media_and_text_EGf74K").offset().top - headerHeight;
        
        // Animate the scroll
        $('html, body').animate({
            scrollTop: targetOffset
        }, 500);
    }
      if (navtitle == 'Ingredients') {
        // Get the height of the header (if it's fixed, adjust accordingly)
        var headerHeight = $('.header-nav').outerHeight()+10; // Adjust selector if needed
        
        // Calculate the position to scroll to
        var targetOffset = $("#ingredients").offset().top - headerHeight;
        
        // Animate the scroll
        $('html, body').animate({
            scrollTop: targetOffset
        }, 500);
      }
     
   });

$(".customer-testimonials-header .button").on("click", function () {
  var $productSection = $("#judgeme_product_reviews");
  
  if ($productSection.length) {
     var headerHeight = $('.header-nav').outerHeight()+ 50;
    var targetOffset = $productSection.offset().top - headerHeight ;

    $('html, body').animate({
      scrollTop: targetOffset
    }, 500);
  } else {
    console.log("Product section not found!");
  }
});



// custom predictive search for blog page
document.addEventListener('DOMContentLoaded', function () {
  let inputSearch = document.querySelector('.custom_input_search');
  let resultsContainer = document.querySelector('.all_article_data_container');
  let noFound = document.querySelector('.article_not_found');

if (!inputSearch || !resultsContainer) return;

inputSearch.addEventListener('input', async function () {
    const query = this.value.toLowerCase().trim();

    // If the input is empty, clear everything and return early
    if (query.length < 1) {
      resultsContainer.style.display = 'none';
      resultsContainer.innerHTML = ""; // Ensure previous results are cleared
      resultsContainer.classList.remove('data-not-available'); // Remove no data class
      noFound?.classList.add('hidden'); // Hide no results message
      return;
    }

    try {
      const response = await fetch(`/search/suggest?q=${encodeURIComponent(query)}&resources[type]=article&section_id=blog-predictive-search`);
      const responseText = await response.text();
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const result = html.querySelector('#shopify-section-blog-predictive-search');

      if (result) {
        resultsContainer.innerHTML = result.innerHTML;
        resultsContainer.style.display = "block";
        resultsContainer.classList.remove('data-not-available');
      } else {
        resultsContainer.innerHTML = "";
        resultsContainer.style.display = "none";
        resultsContainer.classList.add('data-not-available');
      }

      // Filter articles after inserting new content
      const articles = resultsContainer.querySelectorAll('.predictive-search__posts');
      let hasVisibleArticles = false;

      articles.forEach(article => {
        const articleTitle = article.dataset.title?.toLowerCase() || '';
        const articleDate = article.dataset.date?.toLowerCase() || '';
        const articleDescElement = article.querySelector('.article-description');
        const articleDesc = articleDescElement ? articleDescElement.textContent.trim().toLowerCase() : '';

        // Check if the query matches title, date, or description
        const titleCheck = articleTitle.includes(query);
        const dateCheck = articleDate.includes(query);
        const descCheck = articleDesc.includes(query);

        if (titleCheck || dateCheck || descCheck) {
          article.classList.remove("itg-hide-blog");
          hasVisibleArticles = true;
        } else {
          article.classList.add("itg-hide-blog");
        }
      });

      // If no matching articles, hide results and show "no results" message
      if (!hasVisibleArticles) {
        resultsContainer.style.display = "none";
        resultsContainer.classList.add('data-not-available');
        noFound?.classList.remove('hidden'); // Show no results message
      } else {
        resultsContainer.classList.remove('data-not-available');
        noFound?.classList.add('hidden'); // Hide no results message
      }
    } catch (error) {
      console.error("Error fetching predictive search data:", error);
    }
  });
});



// custom share all btn
async function shareContent() {
  try {
    await navigator.share({
      title: document.title,
      url: window.location.href
    });
    console.log('Shared successfully!');
  } catch (error) {
    console.log('Error sharing:', error);
  }
}



// ..........................................................................


// If the sample product is already in the cart, disable its Add to Cart button.
document.addEventListener("DOMContentLoaded", function () {
  let interval;
  const maxDuration = 5000; 
  const checkInterval = 500;
  const startTime = Date.now();

  interval = setInterval(() => {
    const button = document.querySelector(".product-form-submit-wrap .button.sample_button_ATC");
    const productId = button?.dataset.productId;

    if (!button || !productId) return;

    // Fetch cart data
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const productInCart = cart.items.find(item => item.product_id == productId);

        if (productInCart) {
          button.disabled = true;
          button.innerText = "Already in Cart";
          button.style.backgroundColor = "#ccc";
          button.style.cursor = "not-allowed";

          clearInterval(interval);
        }
      });

    if (Date.now() - startTime > maxDuration) {
      clearInterval(interval);
    }

  }, checkInterval);
});



// function toggleOtherTextarea() {
//   const select = document.getElementById('hear_about');
//   const textarea = document.getElementById('other_hear_about');

//   if (select && textarea) {

//     textarea.style.display = (select.value === 'Other (Please Specify)') ? 'block' : 'none';
//   }
// }

// document.getElementById('hear_about')?.addEventListener('change', toggleOtherTextarea);

// window.addEventListener('DOMContentLoaded', () => {
//   toggleOtherTextarea();
// });

 // Function to show/hide textarea and change the 'name' attribute of the select field
  function toggleOtherTextarea() {
    const select = document.getElementById('hear_about');
    const textarea = document.getElementById('other_hear_about');

    if (select && textarea) {
      // If "Other (Please Specify)" is selected
      if (select.value === 'Other (Please Specify)') {
        // Change the name attribute of the select element
        select.setAttribute('name', 'none');
        textarea.style.display = 'block';  // Show the textarea
        textarea.disabled = false; // Enable textarea so the user can type
      } else {
        // If any other option is selected
        select.setAttribute('name', 'properties[How did you hear about Ruba?]'); // Restore the original name attribute
        textarea.style.display = 'none'; // Hide the textarea
        textarea.disabled = true; // Disable the textarea so it's not editable
        textarea.value = ''; // Clear the textarea value
      }
    }
  }

  // Listen for changes in the select element
  document.getElementById('hear_about')?.addEventListener('change', toggleOtherTextarea);

  // Initialize the form when the page loads
  window.addEventListener('DOMContentLoaded', () => {
    toggleOtherTextarea(); // Call the function to show/hide the textarea
  });


// =====================================================================

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".section__featured-product .product__app .jdgm-prev-badge").forEach(function (el) {
      el.addEventListener("click", function () {
        const popup = document.querySelector(".shopify-block section.jdgm-revs-tab__wrapper");
        if (popup) {
          popup.classList.add("jdgm-show");
        }
      });
    });
  });


// js faq block
class CustomFaqRichtextSection extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initFaq();
    }

    initFaq() {
      this.querySelectorAll('.faq-heading').forEach((item) => {
        item.addEventListener('click', () => this.toggleFaq(item));
      });
    }

    toggleFaq(item) {
      console.log('yes clicked');
      let parent = item.closest('.custom-faq-blocks');
      let content = parent.querySelector('.faq-content-custom');

      if (!content) return;

      if (parent.classList.contains('active')) {
        content.style.setProperty('--faq-height', content.scrollHeight + 'px');

        content.classList.add('closing');
        content.addEventListener(
          'animationend',
          () => {
            content.classList.remove('closing');
            parent.classList.remove('active');
            content.style.visibility = 'hidden';
          },
          { once: true }
        );
      } else {
        content.style.setProperty('--faq-height', content.scrollHeight + 'px');

        parent.classList.add('active');
        content.style.visibility = 'visible';
      }
    }
  }

customElements.define('custom-accordian-block', CustomFaqRichtextSection);


// ..............................
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    const ratingText = document.querySelector('.jdgm-rating-text') ? document.querySelector('.jdgm-rating-text').textContent : '';
    
    const badgeTextElement = document.querySelector('.jdgm-prev-badge__text');
    if (badgeTextElement) {
      badgeTextElement.textContent = ratingText;
    }
   }, 1500);
});



// Add marketing checkbox and Klaviyo opt-in to the Shopjar warranty form.
// Shopjar renders asynchronously, so this waits for the required elements.
// It does nothing on pages where the warranty form is not available.
(function () {
  const SHOPJAR_FORM_SELECTOR = '.cr_ram_guest_form_main';
  const SHOPJAR_SUBMIT_CONTAINER_SELECTOR =
    '.cf_ram_guest_submit_button_container';
  const SHOPJAR_SUBMIT_BUTTON_ID =
    'cf_ram_guest_submit_button_container_id';
  const SHOPJAR_EMAIL_ID = 'cf_ram_guest_email_input';
  const CHECKBOX_ID = 'custom_Sj_accepts_marketing';
  const NEWSLETTER_FORM_ID = 'warranty_signup';

  let initialized = false;
  let observer = null;
  let attachRetryTimer = null;

  function getNewsletterMarkup() {
    return `
      <div class="customNewletter_klFm">
        <form
          id="${NEWSLETTER_FORM_ID}"
          action="//manage.kmail-lists.com/subscriptions/subscribe"
          data-ajax-submit="//manage.kmail-lists.com/ajax/subscriptions/subscribe"
          method="GET"
          target="_blank"
          novalidate="novalidate"
        >
          <input type="hidden" name="g" value="XJj2wm">
          <input type="hidden" name="$fields" value="$consent">
          <input type="hidden" name="$list_fields" value="$consent">

          <div class="field popup_error_msg">
            <input
              class="field__input custom_Kl_Newsletter_list"
              id="klaviyo_ctm_input"
              type="email"
              name="email"
              placeholder="Email address"
            >

            <label
              class="field__label"
              for="klaviyo_ctm_input"
            >
              Email address
            </label>

            <div class="klaviyo_messages">
              <div
                class="success_message"
                style="display:none;"
              ></div>

              <div
                class="error_message"
                style="display:none; font-size:14px; margin-top:2px;"
              ></div>
            </div>
          </div>

          <button
            type="submit"
            class="custon_newsL_Kl_btn newsletter-form__button field__button"
            name="commit"
            id="Subscribe"
            aria-label="Subscribe"
          >
            Submit
          </button>
        </form>
      </div>
    `;
  }

  function addMarketingCheckbox(submitContainer) {
    if (document.getElementById(CHECKBOX_ID)) return;

    submitContainer.insertAdjacentHTML(
      'beforebegin',
      `
        <div class="Sj_marketing_checkbox">
          <label class="label-with-checkbox">
            <input
              id="${CHECKBOX_ID}"
              class="checkbox"
              type="checkbox"
            >
            Get friendly emails from Ruba
          </label>
        </div>
      `
    );
  }

  function addHiddenNewsletterForm(shopjarForm) {
    if (document.getElementById(NEWSLETTER_FORM_ID)) return;

    shopjarForm.insertAdjacentHTML(
      'beforebegin',
      getNewsletterMarkup()
    );
  }

  function hideNewsletterFormAfterSuccess() {
    const emailInput = document.querySelector(
      `#${NEWSLETTER_FORM_ID} #klaviyo_ctm_input`
    );

    const submitButton = document.querySelector(
      `#${NEWSLETTER_FORM_ID} #Subscribe`
    );

    const contentInner = document.querySelector(
      '.content_inner_p'
    );

    if (emailInput) {
      emailInput.style.display = 'none';
    }

    if (submitButton) {
      submitButton.style.display = 'none';
    }

    if (contentInner) {
      contentInner.style.display = 'none';
    }
  }

  function attachKlaviyoForm() {
    const form = document.getElementById(
      NEWSLETTER_FORM_ID
    );

    if (
      !form ||
      form.dataset.klaviyoAttached === 'true'
    ) {
      return false;
    }

    if (
      typeof window.KlaviyoSubscribe === 'undefined' ||
      typeof window.KlaviyoSubscribe.attachToForms !==
        'function'
    ) {
      return false;
    }

    window.KlaviyoSubscribe.attachToForms(
      `#${NEWSLETTER_FORM_ID}`,
      {
        hide_form_on_success: true,

        success: hideNewsletterFormAfterSuccess,

        extra_properties: {
          $source: 'Warranty Signup Form',
          $method_type: 'Custom Klaviyo Form',
          $consent_version: ''
        }
      }
    );

    form.dataset.klaviyoAttached = 'true';

    return true;
  }

  function syncShopjarEmail() {
    const shopjarInput = document.getElementById(
      SHOPJAR_EMAIL_ID
    );

    const newsletterInput = document.querySelector(
      '.custom_Kl_Newsletter_list'
    );

    if (
      !shopjarInput ||
      !newsletterInput ||
      shopjarInput.dataset.rubaEmailSync === 'true'
    ) {
      return;
    }

    function copyEmail() {
      newsletterInput.value =
        shopjarInput.value || '';
    }

    shopjarInput.addEventListener(
      'input',
      copyEmail
    );

    shopjarInput.addEventListener(
      'change',
      copyEmail
    );

    shopjarInput.dataset.rubaEmailSync = 'true';

    copyEmail();
  }

  function bindShopjarSubmit() {
    const shopjarSubmitButton =
      document.getElementById(
        SHOPJAR_SUBMIT_BUTTON_ID
      );

    const marketingCheckbox =
      document.getElementById(
        CHECKBOX_ID
      );

    const newsletterSubmitButton =
      document.querySelector(
        '.custon_newsL_Kl_btn'
      );

    if (
      !shopjarSubmitButton ||
      !marketingCheckbox ||
      !newsletterSubmitButton ||
      shopjarSubmitButton.dataset.rubaMarketingBound ===
        'true'
    ) {
      return;
    }

    shopjarSubmitButton.addEventListener(
      'click',
      function () {
        if (!marketingCheckbox.checked) return;

        const shopjarInput =
          document.getElementById(
            SHOPJAR_EMAIL_ID
          );

        const newsletterInput =
          document.querySelector(
            '.custom_Kl_Newsletter_list'
          );

        if (
          shopjarInput &&
          newsletterInput
        ) {
          newsletterInput.value =
            shopjarInput.value || '';
        }

        newsletterSubmitButton.click();
      }
    );

    shopjarSubmitButton.dataset.rubaMarketingBound =
      'true';
  }

  function initializeShopjarIntegration() {
    if (initialized) return true;

    const shopjarForm =
      document.querySelector(
        SHOPJAR_FORM_SELECTOR
      );

    const submitContainer =
      document.querySelector(
        SHOPJAR_SUBMIT_CONTAINER_SELECTOR
      );

    if (
      !shopjarForm ||
      !submitContainer
    ) {
      return false;
    }

    addMarketingCheckbox(
      submitContainer
    );

    addHiddenNewsletterForm(
      shopjarForm
    );

    syncShopjarEmail();

    bindShopjarSubmit();

    initialized = true;

    if (!attachKlaviyoForm()) {
      let attempts = 0;

      attachRetryTimer =
        window.setInterval(
          function () {
            attempts += 1;

            const successfullyAttached =
              attachKlaviyoForm();

            if (
              successfullyAttached ||
              attempts >= 20
            ) {
              window.clearInterval(
                attachRetryTimer
              );

              attachRetryTimer = null;
            }
          },
          500
        );
    }

    if (observer) {
      observer.disconnect();
      observer = null;
    }

    return true;
  }

  function startShopjarObserver() {
    if (
      initializeShopjarIntegration()
    ) {
      return;
    }

    observer = new MutationObserver(
      function () {
        initializeShopjarIntegration();
      }
    );

    observer.observe(
      document.documentElement,
      {
        childList: true,
        subtree: true
      }
    );

    window.setTimeout(
      function () {
        if (observer) {
          observer.disconnect();
          observer = null;
        }
      },
      15000
    );
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      startShopjarObserver,
      {
        once: true
      }
    );
  } else {
    startShopjarObserver();
  }
})();